import { render, staticRenderFns } from "./submissions.vue?vue&type=template&id=2dc38895&scoped=true"
import script from "./submissions.vue?vue&type=script&lang=js"
export * from "./submissions.vue?vue&type=script&lang=js"
import style0 from "./submissions.vue?vue&type=style&index=0&id=2dc38895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc38895",
  null
  
)

export default component.exports